const proxy = "https://corsproxy.io/?";

const mediaUrl =
  proxy + "https://media.themoviedb.org/t/p/w533_and_h300_bestv2";

const movieListAPI =
  proxy +
  "https://api.themoviedb.org/3/discover/movie?include_adult=false&include_video=false&language=en-US&sort_by=popularity.desc&page=";

const options = {
  method: "GET",
  headers: {
    accept: "application/json",
    Authorization:
      "Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJlYmNjNzQ5MmZmYTY1YWFkYmI5YTUzNzljYWE1ZWE1OSIsInN1YiI6IjY2MzA5YWU5ZDdhNzBhMDEyM2Q5MDFjOSIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.RBHbILXdJblqqxFyJRvSOcuCbmAhS_5kR4Pxv28hzP8",
  },
};

export { movieListAPI, options, mediaUrl };
